export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 11 Checkout 2 Now Open.de5273c1.mp3";